/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./websocket.vue?vue&type=template&id=c2b3873a&scoped=true"
import script from "./websocket.vue?vue&type=script&lang=js"
export * from "./websocket.vue?vue&type=script&lang=js"
import style0 from "./websocket.vue?vue&type=style&index=0&id=c2b3873a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b3873a",
  null
  
)

export default component.exports